import styled from "styled-components";

const StyledSidebarListElement = styled.li`
  padding: 0 0.5rem 0;
  list-style-type: none;
  user-select: none;
`;

export default StyledSidebarListElement;
